import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { datePramaSet } from "js/function";
import { CarDetailItem, CarListItem } from "component/product/car";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { CarDetailControllBasicText, CarDetailControllBox, FixedContents } from "component/product/page";

const ReservationEditCarList = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;

    const location = useLocation();
    const locationData = location?.state ? location?.state : null;
    const paymentData = locationData?.paymentData;
    const pageData = locationData?.pageData;
    const memberCode = locationData?.memberCode;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(false);

    const carListDataApi = useGet({
        url:`/reservation/car?start_date=${paymentData?.start_date ? datePramaSet(paymentData?.start_date) : pageData?.start_date ? datePramaSet(pageData?.start_date) : ""}
        &end_date=${paymentData?.end_date ? datePramaSet(paymentData?.end_date) : pageData?.end_date ? datePramaSet(pageData?.end_date) : ""}
        &insurance_id=${(paymentData?.insurance_id ? paymentData?.insurance_id : pageData?.insurance_id)||""}`,
        loginType:"login"
    });
    const carListData = carListDataApi?.data?.cars;

    useEffect(() => {
        if(!((paymentData?.start_date && paymentData?.end_date) || (pageData?.start_date && pageData?.end_date))){
            navigate("/pageErr")
        }
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                addClass={"gBg mBtnPoint"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"일정 변경"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={1}
                    closeFunc={()=>{}}
                />

                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailItem
                            itemType="edit"
                            sectionTitle="기존 차량 정보"
                            sectionCaptions={null}
                            status={null}
                            model_id={pageData?.model_id}
                            car_image={pageData?.image_url}
                            car_image_alt={pageData?.image_alt}
                            maker={pageData?.maker}
                            modelName={pageData?.name}
                            passengerNum={pageData?.passenger_number}
                            fuelType={pageData?.fuel}
                            min_year={pageData?.min_year}
                            max_year={pageData?.max_year}
                            car_option={pageData?.options}
                            carOptionDisable={pageData?.non_options}
                            insurance_name={pageData?.insurance_name}
                        />
                        <div className="editCarListBox">
                            {carListData && carListData?.length > 0 ? 
                                <>
                                    {carListData && carListData?.map((item, i) => (
                                        <CarListItem
                                            key={i}
                                            type="rent"
                                            addClass=""
                                            id={item?.id}
                                            model_id={item?.model_id}
                                            car_image={item?.image_url}
                                            car_image_alt={item?.image_alt}
                                            maker={item?.maker}
                                            modelName={item?.name}
                                            passengerNum={item?.passenger_number}
                                            fuelType={item?.fuel}
                                            min_year={item?.min_year}
                                            max_year={item?.max_year}
                                            insuranceName={pageData?.insurance_name||null}
                            
                                            carOptions={item?.options}
                            
                                            carCategory={item?.type}
                                            eventRate={item?.specialEventRate}
                                            discount_price={item?.discount_price}
                                            original_price={item?.original_price}
                            
                                            mImgChk={true}

                                            func={()=>{
                                                navigate(`/edit/detail/${id}/${item.companyMappedCode}/${item.modelMappedCode}`,{state:{paymentData:paymentData,pageData:pageData,memberCode:memberCode}})
                                            }}
                                        />
                                    ))}
                                </>
                            :
                                <NotItems addClass="fullPage" text={`조건에 맞는 차량이 없습니다.`}/>
                            }
                        </div>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <CarDetailControllBox
                            addClass={"nonFixed"}
                            title={"변경할 차량을 선택해주세요."}
                            subTitle={null}
                        >
                            <CarDetailControllBasicText
                                addClass="subText"
                                text={"대여/반납일정 내 변경 가능한 차량만을 조회합니다."}
                            />
                            <BtnBox
                                boxType=""
                                addClass={"mFixed"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <Footer pcOnly={true}/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default ReservationEditCarList;